export default [
  {
    label: 'Public M&A',
    value: 'pma'
  },
  {
    label: 'IPOs',
    value: 'ipo'
  },
  {
    label: 'Secondary Offers',
    value: 'so'
  }
]
